import { gql, type TypedDocumentNode } from "@apollo/client";
import type { RecentlyAssumedUserRow } from "./queries";

export type RecordRecentlyAssumedUserResponse = {
  recordRecentlyAssumedUser: {
    success: boolean;
    message: string | null;
    recentlyAssumedUsers: RecentlyAssumedUserRow[];
  };
};

export type RecordRecentlyAssumedUserVariables = {
  assumedUserId: string;
};

export const RECORD_RECENTLY_ASSUMED_USER_MUTATION: TypedDocumentNode<
  RecordRecentlyAssumedUserResponse,
  RecordRecentlyAssumedUserVariables
> = gql`
  mutation RecordRecentlyAssumedUser($assumedUserId: ID!) {
    recordRecentlyAssumedUser(assumedUserId: $assumedUserId) {
      success
      message
      recentlyAssumedUsers {
        id
        assumedAt
        user {
          id
          name
          email
          photo
          department
        }
      }
    }
  }
`;
